import React, { useState } from 'react';
import { capitalCase } from 'capital-case';
import { bool, func, string } from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import FuzzySearch from 'fuzzy-search';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FaRegAddressBook } from 'react-icons/fa';
import ReactSlidingPane from '../../components/ReactSlidingPane';
import DropDownSelect from '../../components/DropDownSelect';
import { useQuery } from 'react-query';
import { chrApi } from '../../api/api';
import { usePracticeProviderContext } from '../../context/PracticeProviderContext';
import { FormCheck } from 'react-bootstrap';
import ExternalContactForm from '../SecureShare/ExternalContactForm';
import { FilterComponent } from '../SecureShare/ExternalContactTable';
import useLocalStorage from '@rehooks/local-storage';

function useExternalContact(userId, contactType, userType, onSuccessCb = () => {}) {
  return useQuery(`fetch${contactType}`, () => chrApi('get', `external_contact?userId=${userId}&type=${contactType}&userType=${userType}`).then((res) => res.data), {
    enabled: !!contactType,
    onSuccess: (data) => {
      onSuccessCb(data);
    },
  });
}

function QMEExternalContactLookupPane(props) {
  const { isOpen, onClose, onSelect, contactType } = props;
  const [filterText, setFilterText] = React.useState('');
  const { provider: userId } = usePracticeProviderContext();

  const [selectedContact, setSelectedContact] = useState({});
  const [showNewContactUI, setShowNewContactUI] = useState(false);
  const [userType] = useLocalStorage('__type__');

  const { data: externalContacts = [], refetch } = useExternalContact(props.userId || userId, contactType, userType);

  const searcher = new FuzzySearch(externalContacts, ['firstName', 'lastName', 'email']);

  const filteredExternalContact = searcher.search(filterText);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setFilterText('');
      }
    };

    return <FilterComponent onFilter={(e) => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />;
  }, [filterText]);

  function selectExternalContact() {
    return (
      <>
        <Row className={'d-flex justify-content-between mr-3 my-2'}>
          <div className={'pl-3'} style={{ minWidth: 200 }}>
            {subHeaderComponentMemo}
          </div>
          <Button
            size={'sm'}
            variant={'fff'}
            onClick={() => {
              setShowNewContactUI(true);
            }}
          >
            <FaRegAddressBook className={'mb-1 mr-1'} />
            New Contact
          </Button>
        </Row>
        <div style={{ height: '75vh', overflow: 'auto' }}>
          {filteredExternalContact.map((row) => {
            const { id, firstName = '', lastName = '', email } = row;
            return (
              <FormCheck
                type="radio"
                name={'externalContact'}
                checked={id === selectedContact?.id}
                key={id}
                className={'my-2'}
                label={`${firstName} ${lastName} ${email ? '(' + email + ')' : ''}`}
                onChange={(e) => {
                  setSelectedContact(row);
                }}
              />
            );
          })}
        </div>
        <Row className={'fixed-bottom m-2'}>
          <Col>
            <Button
              disabled={externalContacts.length === 0}
              size={'sm'}
              onClick={() => {
                if (!selectedContact) return;
                onSelect({ contactType, selectedContact });
                onClose();
              }}
              className={'mr-2 px-4'}
              variant={'primary'}
            >
              Select
            </Button>
            <Button onClick={onClose} size={'sm'} className={'px-4'} variant={'fff'}>
              Cancel
            </Button>
          </Col>
        </Row>
      </>
    );
  }
  return (
    <ReactSlidingPane
      className={'custom-sliding-pane'}
      state={isOpen}
      onClose={() => {
        if (showNewContactUI) setShowNewContactUI(false);
        else onClose();
      }}
      title={capitalCase(contactType)}
    >
      <Container fluid>{showNewContactUI ? <ExternalContactForm onSaveCb={() => setShowNewContactUI(false)} onCancelCb={() => setShowNewContactUI(false)} /> : selectExternalContact()}</Container>
    </ReactSlidingPane>
  );
}

QMEExternalContactLookupPane.propTypes = {
  isOpen: bool,
  onClose: func,
  onSelect: func,
  contactType: string,
  userId: string,
};
QMEExternalContactLookupPane.defaultProps = {};

export default QMEExternalContactLookupPane;
